import { AfterViewInit, Directive, ElementRef, Input, OnChanges, SimpleChanges } from '@angular/core';
import { NbMenuItem } from '@nebular/theme';

@Directive({
  selector: '[kwRemoveChildren]'
})
export class RemoveChildrenDirective implements OnChanges,AfterViewInit{
  @Input() items:NbMenuItem[];

  constructor(private el:ElementRef<HTMLElement>) { }
  
  ngAfterViewInit(): void {
    const menuUl:HTMLElement = this.el.nativeElement.querySelector('ul.menu-items');
    if(menuUl != undefined){
      const menuItems = menuUl.querySelectorAll('li');
      if(menuItems != undefined){
        for(let i=0;i < menuItems.length;i++){
          let hrefEls = menuItems[i].getElementsByTagName('A');
          if(hrefEls != undefined){
            hrefEls[0].removeAttribute("href");
          }
          let subMenuUl = menuItems[i].querySelector('ul.menu-items');
          if(subMenuUl != undefined){
            subMenuUl.remove();
          }
        }
      }
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes["items"]){
      console.log(this.items)
    }
  }



}
